module.exports = __webpack_public_path__ + "static/media/cc-checklist.133aad2e.svg";